<div class="login-page">
    <div class="well container">
        <div class="well-title">
            <div class="col-md-12">Forgot your password?</div>
        </div>
        <div class="col-md-8 well-content">
            @if (!submitted) {
                <form class="form-horizontal" role="form" [formGroup]="form" (ngSubmit)="onSubmit()">
                    <h4>Enter your email.</h4>
                    <hr />
                    @if (errorMessage) {
                        <div class="alert alert-danger">{{ errorMessage }}</div>
                    }
                    <div class="form-group">
                        <label class="col-md-2 control-label" for="email">Email</label>
                        <div class="col-md-10">
                            <input
                                id="email"
                                type="text"
                                class="form-control"
                                formControlName="email"
                                autocomplete="username" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2 col-md-10">
                            <button type="submit" class="btn btn-default" [disabled]="submitting">
                                {{ submitting ? "Sending..." : "Email Link" }}
                            </button>
                        </div>
                    </div>
                </form>
                <a routerLink="/account/login">Go back to login.</a>
            }

            @if (submitted) {
                <p>
                    Please check your email to reset your password.
                    <a routerLink="/account/login">Go back to login.</a>
                </p>
            }
        </div>
    </div>
</div>
